export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-3a-4a6f2c2911b4eda75b684a3dc756c2d2.webp";